import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Box, Card, useTheme, CircularProgress } from "@mui/material"
import { selectChildPractices, selectCustomerNumber, selectGroups, selectLoadingState } from '../../../redux/customer'
import PageHeader from "../../../components/PageHeader"
import GroupSelect from './GroupSelect'
import NoGroups from './NoGroups'
import GroupTransferWrapper from './GroupTransferWrapper'
import GroupActions from './GroupActions'
import GroupDialogs from './GroupDialogs'
import { Groups, LoadingState, OpenGroupModal } from '../../../types'
import './Groups.css'

const GroupsWrapper = () => {
  const theme = useTheme()

  const groups = useSelector(selectGroups)
  const customerNumber = useSelector(selectCustomerNumber)
  const childPractices = useSelector(selectChildPractices)
  const loadingState = useSelector(selectLoadingState)

  const [selectedGroup, setSelectedGroup] = useState<Groups | null>(null)
  const [groupId, setGroupId] = useState<number | null>(null)
  const [openModal, setOpenModal] = useState<OpenGroupModal>({ open: false, type: '' })

  const isLoading = loadingState === LoadingState.Loading

  const subHeaderClass = isLoading
    ? ' flex-center' 
    : selectedGroup ? ' flex-space-between' : ' c-g-16'

  useEffect(() => {
    if (groupId) {
      const group = groups?.find(group => group.group_id === groupId) ?? null
      setSelectedGroup(group)
    }
  }, [groupId, groups])

  return (
    <>
      <PageHeader iconName="users" headerName="Groups" />
      <Box sx={{ width: '100%', p: 2, color: theme.palette.color50555b.main }} className="groups-container">
        <Card sx={{ width: "100%" }} variant="outlined">
          <div className="box-header">Manage Groups</div>
          <div className={`table-subheader${subHeaderClass}`} style={{ flexWrap: 'wrap'}}>
            {
              isLoading ? <CircularProgress size="3rem" /> : null
            }
            {
              !isLoading && customerNumber && groups.length 
                ?
                  <>
                    <GroupSelect
                      groups={groups}
                      groupId={groupId}
                      setGroupId={setGroupId}
                    />
                    <GroupActions
                      setOpenModal={setOpenModal}
                      selectedGroup={selectedGroup}
                    />
                  </>
                : null
            }
            {
              !isLoading && customerNumber && !groups.length 
                ? <NoGroups setOpenModal={setOpenModal} />
                : null
            }
            {
              Boolean(selectedGroup)
                ?
                  <GroupTransferWrapper
                    selectedGroup={selectedGroup}
                    childPractices={childPractices}
                    customerNumber={customerNumber}
                  />
                : null
            }
          </div>
        </Card>
      </Box>
      <GroupDialogs
        openModal={openModal}
        customerNumber={customerNumber}
        selectedGroup={selectedGroup}
        setOpenModal={setOpenModal}
        setGroupId={setGroupId}
        setSelectedGroup={setSelectedGroup}
      />
    </>
  )
}

export default GroupsWrapper